import type { NextPage } from 'next'

interface IProps {
  position?: 'top' | 'bottom' | 'left' | 'right';
  theme?: 'default' | 'primary' | 'success' | 'danger' | 'warning' | 'info';
  message: string;
}

export const Component: NextPage<IProps> = ({ position, theme, message, children }) => {
  const pickedTheeme = theme || 'info';
  const themeSet = (pickedTheeme !== 'default') ? `bg-button-${pickedTheeme}-bg text-button-${pickedTheeme}-text` : 'bg-gray-600 text-white';
  const pickedPosition = position || 'top';
  return (
    <div className={`relative flex flex-col items-center group`}>
      {children}
      {pickedPosition === 'top' && (
        <div className="absolute bottom-0 flex-col items-center hidden mb-6 group-hover:flex">
          <span className={`relative z-10 p-2 text-xs leading-none whitespace-no-wrap rounded-md shadow-lg ${themeSet}`}>{message}</span>
          <div className={`w-3 h-3 -mt-2 rotate-45 ${themeSet}`}></div>
        </div>
      )}
      {pickedPosition === 'bottom' && (
        <div className="absolute top-0 flex-col items-center hidden mt-6 group-hover:flex">
          <div className={`w-3 h-3 mt-0 rotate-45 ${themeSet}`}></div>
          <span className={`relative z-10 -mt-2 p-2 text-xs leading-none whitespace-no-wrap rounded-md shadow-lg ${themeSet}`}>{message}</span>
        </div>
      )}
      {/* {pickedPosition === 'left' && (
        <div className="absolute right-0 flex items-center top-1 group-hover:flex">
          <span className={`relative z-10 -mt-2 p-2 text-xs leading-none whitespace-no-wrap rounded-md shadow-lg ${themeSet}`}>{message}</span>
          <div className={`relative w-3 h-3 -ml-2 mb-2 rotate-45 ${themeSet}`}></div>
        </div>
      )} */}
    </div>
  );
};

export default Component;
